/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_ByInputs */



/**

* @param {_Wiki_ByInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _wiki_by = /** @type {((inputs?: _Wiki_ByInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_ByInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("von")
});